"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../model/utils");
var wrapper_1 = require("../utils/wrapper");
var constant_1 = require("../utils/constant");
var fetchBooking = function (getBookingParams) {
    return wrapper_1.getClients()
        .restClient.get(constant_1.FETCH_BOOKING_URL + "/" + getBookingParams.id + "/detail")
        .then(function (_a) {
        var data = _a.data;
        return ({ data: data });
    })
        .catch(utils_1.errorHandler);
};
var deleteBooking = function (deleteBookingParams) {
    var _a;
    // Enpoint semantic is bad, it should return empty body with a 204 response
    return (_a = wrapper_1.getClients()) === null || _a === void 0 ? void 0 : _a.restClient.delete(constant_1.FETCH_BOOKING_URL + "/" + deleteBookingParams.id).then(function () { return ({ data: true }); }).catch(utils_1.errorHandler);
};
var isAvailabilityBooking = function (createBookingParams) {
    return wrapper_1.getClients()
        .restClient.post("" + constant_1.FETCH_CHECK_AVAILABILITY_URL, createBookingParams)
        .then(function () { return ({ data: true }); })
        .catch(utils_1.errorHandler);
};
var createBooking = function (createBookingParams) {
    return wrapper_1.getClients()
        .restClient.post("" + constant_1.FETCH_BOOKING_CREATE_URL, createBookingParams)
        .then(function (_a) {
        var data = _a.data;
        return ({ data: data });
    })
        .catch(utils_1.errorHandler);
};
var checkAndCreateBooking = function (createBookingParams) {
    return wrapper_1.getClients()
        .restClient.post("" + constant_1.FETCH_CHECK_AVAILABILITY_URL, createBookingParams)
        .then(function () { return createBooking(createBookingParams); })
        .catch(utils_1.errorHandler);
};
var patchBookingService = function (_a) {
    var id = _a.id, params = __rest(_a, ["id"]);
    return wrapper_1.getClients()
        .restClient.patch(constant_1.PATCH_BOOKING_SERVICE_URL + "/" + id, params)
        .catch(utils_1.errorHandler);
};
var patchBooking = function (_a) {
    var id = _a.id, params = __rest(_a, ["id"]);
    return wrapper_1.getClients()
        .restClient.patch(constant_1.FETCH_BOOKING_URL + "/" + id, params)
        .catch(utils_1.errorHandler);
};
var moveBooking = function (_a) {
    var id = _a.id, params = __rest(_a, ["id"]);
    return wrapper_1.getClients()
        .restClient.put(constant_1.FETCH_BOOKING_URL + "/" + id + "/move", params)
        .catch(utils_1.errorHandler);
};
var booking = {
    fetchBooking: fetchBooking,
    deleteBooking: deleteBooking,
    createBooking: createBooking,
    checkAndCreateBooking: checkAndCreateBooking,
    isAvailabilityBooking: isAvailabilityBooking,
    patchBookingService: patchBookingService,
    patchBooking: patchBooking,
    moveBooking: moveBooking,
};
var init = function () { return booking; };
exports.init = init;
